import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CartContextProvider } from '@fff-web/fff-cart';

import useCartData from 'pages/MyAccount/hooks/useCartData';
import { receiveUpdateCart as receiveUpdateCartAction } from 'pages/MyAccount/services/actions/cartActions';
import { receiveCartProducts as receiveCartProductsAction } from 'pages/MyAccount/services/actions/productsActions';
import {
  openInviteModal as openInviteModalAction,
  receiveTeamCarts as receiveTeamCartsAction,
} from 'pages/MyAccount/services/actions/socialEcommActions';
import { VERSION } from 'pages/MyAccount/utils/campaign';

const CUSTOMIZE_ADDITIONAL_CHOICE = 'CUSTOMIZE_ADDITIONAL_CHOICE';

const CartContext = ({
  version,
  cartDetails,
  account,
  products,
  variants,
  children,
  receiveUpdateCart,
  invitations,
  teamId,
  openInviteModal,
  receiveTeamCarts,
  socialAvatars,
  teamCartData,
  receiveCartProducts,
}) => {
  const history = useHistory();
  const { prevPurchasedVariantQuantities, customizeCampaignDetails } =
    cartDetails;
  const cartData = useCartData(
    cartDetails,
    products,
    variants,
    prevPurchasedVariantQuantities,
    customizeCampaignDetails
  );
  const isEditPage = version === VERSION.edit;
  const isSalePage =
    version === VERSION['add-ons'] || isEditPage || version === VERSION.shop;

  const onClickProduct = ({ pathname, search, variant }) => {
    if (
      variant.variantType === CUSTOMIZE_ADDITIONAL_CHOICE &&
      variant.questionId
    ) {
      window.location.href = `/new-member-customize/?q=${variant.questionId}`;
    } else {
      history.push({
        pathname,
        search,
      });
    }
  };

  return (
    <CartContextProvider
      cartData={cartData}
      account={account}
      receiveUpdateCart={isSalePage && receiveUpdateCart}
      onClickProduct={onClickProduct}
      invitations={invitations}
      teamId={teamId}
      openInviteModal={openInviteModal}
      receiveTeamCarts={isEditPage && receiveTeamCarts}
      socialAvatars={isEditPage && socialAvatars}
      teamCartData={isEditPage && teamCartData}
      receiveCartProducts={isSalePage && receiveCartProducts}
    >
      {children}
    </CartContextProvider>
  );
};

const mapStateToProps = (state) => ({
  cartDetails: state.cartState,
  account: state.userState,
  products: state.productsState.products,
  variants: state.productsState.variants,
  invitations: state.socialEcommState.invitations.available,
  teamId: state.socialEcommState.team.teamId,
  socialAvatars: state.socialEcommState.socialAvatars,
  teamCartData: state.socialEcommState.teamCart,
});

const mapDispatchToProps = {
  receiveUpdateCart: receiveUpdateCartAction,
  openInviteModal: openInviteModalAction,
  receiveTeamCarts: receiveTeamCartsAction,
  receiveCartProducts: receiveCartProductsAction,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CartContext
);
